import {
  PublicDemandInterestFormDetails,
  SendPublicDemandInterestFormPayload,
  SendPublicDemandInterestFormResponse,
} from '@features/public-demand-interest-form/utils/models/public-demand-interest-form.model';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { HttpError } from '@shared/utils/models/http.model';

export const PublicDemandInterestFormActions = createActionGroup({
  source: 'Public Demand Interest Form',
  events: {
    'Validate Demand Interest Form': props<{ demandHash: string }>(),
    'Validate Demand Interest Form Success': props<{ data: PublicDemandInterestFormDetails }>(),
    'Validate Demand Interest Form Failure': props<{ error: HttpError }>(),
    'Send Demand Interest Form': props<{ payload: SendPublicDemandInterestFormPayload }>(),
    'Send Demand Interest Form Success': props<{ data: SendPublicDemandInterestFormResponse }>(),
    'Send Demand Interest Form Failure': props<{ error: HttpError }>(),
  },
});

export const PublicDemandInterestFormResetActions = createActionGroup({
  source: 'Public Demand Interest Form',
  events: {
    'Cancel Public Demand Interest Form Actions': emptyProps(),
    'Cancel Public Demand Interest Form Actions Success': emptyProps(),
    'Reset Public Demand Interest Form': emptyProps(),
  },
});
